export default __webpack_public_path__ + "static/media/map-bg@2x.ab0f088a.png";